import { createContext, useContext, useEffect, useState } from "react";
import api from '../services/api';
import { useAuth } from "../context/AuthContext"; // Import Auth Context to listen for login changes

const CompanyContext = createContext();

export const CompanyProvider = ({ children }) => {
  const [company, setCompany] = useState(null);
  const { user } = useAuth(); // Get the logged-in user from AuthContext

  useEffect(() => {
    if (!user) return; // Prevent fetching if the user is not logged in

    api.get("/Companies/current")
      .then((response) => setCompany(response.data))
      .catch((error) => console.error("Error fetching company:", error));
  }, [user]); // Re-fetch when the user changes

  return <CompanyContext.Provider value={company}>{children}</CompanyContext.Provider>;
};

export const useCompany = () => useContext(CompanyContext);
